import store from '../store';
import {
    fetchJobs as fetchJobsRedux,
    createJob as createJobRedux,
    loadResult as loadResultRedux,
    removeJob as removeJobRedux,
    cancelJob as cancelJobRedux,
} from './thunks';
import {
    updateLocalJobState as updateLocalJobStateRedux,
    updateDisplayedCompoundJobs as updateDisplayedCompoundJobsRedux,
    updateDisplayedScreeningJobs as updateDisplayedScreeningJobsRedux,
    updateDisplayedFreeEnergyJobs as updateDisplayedFreeEnergyJobsRedux,
    updateDisplayedMdJobs as updateDisplayedMdJobsRedux,
    setJobState as setJobStateRedux,
} from '.';

export function fetchJobs() {
    return store.dispatch(fetchJobsRedux());
}

export function getJobState() {
    return store.getState().jobs;
}

export function createJob(jobType, data, stash) {
    return store.dispatch(createJobRedux(jobType, data, stash));
}

export function loadResult(jobid, options) {
    return store.dispatch(loadResultRedux(jobid, options));
}

export function removeJob(jobid) {
    return store.dispatch(removeJobRedux(jobid));
}

export function cancelJob(jobid) {
    return store.dispatch(cancelJobRedux(jobid));
}

export function updateLocalJobState(jobid, data) {
    return store.dispatch(updateLocalJobStateRedux({ jobid, ...data }));
}

export function updateDisplayedCompoundJobs(data) {
    return store.dispatch(updateDisplayedCompoundJobsRedux(data));
}

export function updateDisplayedScreeningJobs(data) {
    return store.dispatch(updateDisplayedScreeningJobsRedux(data));
}

export function updateDisplayedFreeEnergyJobs(data) {
    return store.dispatch(updateDisplayedFreeEnergyJobsRedux(data));
}

export function updateDisplayedMdJobs(data) {
    return store.dispatch(updateDisplayedMdJobsRedux(data));
}

export function setJobState(state) {
    return store.dispatch(setJobStateRedux(state));
}
